/* This file is autogenerated, see readme.md for instructions */
import SuggestionSvgIcon from '@bloomreach/banana-theme/icons/suggestion.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SuggestionIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SuggestionSvgIcon />
    </Icon>
  );
});

SuggestionIcon.displayName = 'SuggestionIcon';

export default SuggestionIcon;
